"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLinkedEventsIds = exports.getLinkedEventIds = void 0;
const getLinkedEventIds = (event) => {
    try {
        if (!event.linkedEvents) {
            return [];
        }
        return event.linkedEvents.map((linkedEvent) => linkedEvent.eventId);
    }
    catch (e) {
        console.error("Couldn't extract linked events ids for event", e);
        return [];
    }
};
exports.getLinkedEventIds = getLinkedEventIds;
const getLinkedEventsIds = (events) => {
    try {
        return events.flatMap(exports.getLinkedEventIds);
    }
    catch (e) {
        console.error("Couldn't extract linked events ids from events", e);
        return [];
    }
};
exports.getLinkedEventsIds = getLinkedEventsIds;
//# sourceMappingURL=linkedEvents.js.map